// extracted by mini-css-extract-plugin
export var numpadContainer = "_ku-1";
export var phoneButton = "_ku-0";